import { render } from "./EditOrganisationDailyReportPositions.vue?vue&type=template&id=2950e586"
import script from "./EditOrganisationDailyReportPositions.vue?vue&type=script&lang=js"
export * from "./EditOrganisationDailyReportPositions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__